import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectActiveGame, selectUser } from '../ActiveGame/selectors';
import { Bar, Name, Presence, TurnDot } from './styled';
import { selectIsOnline } from '../Presence';
import Avatar from '../Avatar';

/**
 * A player: whose turn, their picture and name, and whether they're here. Prizes, deck and hands are on the board
 * itself (the opponent's hand is held past its far edge).
 */
const PlayerBar = ({ userId, you }) => {
  const game = useSelector(selectActiveGame);
  const user = useSelector((state) => selectUser(state, { userId }));
  const theirTurn = game.get('active_player_id') === userId && !game.get('ended_at');
  // The opponent's dot: whether they have the game open now; the computer always has.
  const present = useSelector((state) => selectIsOnline(state, { gameId: game.get('id'), userId }));
  const online = present || !!(user && user.get('computer'));
  const showsPresence = !you && !!user;

  return (
    <Bar>
      <Avatar user={user} size={22} game={game.get('id')} />
      <Name>
        {you ? 'You' : user && user.get('name')}
        {showsPresence && <Presence $online={online} title={online ? 'Online now' : 'Not here right now'} aria-label={online ? 'Online now' : 'Not here right now'} />}
      </Name>
      {/* Right of the name, as on both bars: whose turn it is. */}
      {theirTurn && <TurnDot aria-label={you ? 'Your turn' : 'Their turn'} />}
    </Bar>
  );
};

PlayerBar.propTypes = {
  userId: PropTypes.number.isRequired,
  you: PropTypes.bool,
};

export default PlayerBar;
